// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"28eaf636","772":"4cb73e19"}[chunkId] + ".chunk.js";
};